import { Card, message, Modal, Spin, Tooltip, Typography, UploadFile } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { CompleteTickets, InprogressTickets, TicketDetail, UpdateObstacleTicketRequest } from 'types';
import { requestform } from 'messages';
import { PrinterIcon } from 'assets';
import { GetTicketDetail } from 'hooks/request-form';
import RequestDetailCreateFormInformation from './RequestDetailCreateFormInformation';
import RequestDetailMainInformation from './RequestDetailMainInformation';
import {
  usePatchAssignCrmAppTaskMutation,
  usePatchCompleteCollaborationTicketMutation,
  usePatchCompleteObstacleTicketMutation,
  usePatchCompleteTicketMutation,
  usePatchInprogressTicketMutation,
  usePatchReceptionTicketMutation,
  usePatchTurnOffTicketPriorityMutation,
  usePatchUpdateObstacleTicketMutation
} from 'services';
import ModalTransferCmis from './Modal/ModalTransferCmis';
import ModalTransferUnit from './Modal/ModalTransferUnit';
import RequestStatusBar from './RequestStatusBar';
import defaultTicketDetail, { CompleteCollaborationTicketRequest } from 'types/dto/request-form/request-form.dto';
import RequestDetailProcessing from './RequestDetailProcessing';
import ModalObstacle from './Modal/ModalObstacle';
import PrintComponent from '../print-ticket/PrintTikcet';
import NormalTicket from '../print-ticket-detail/NormalTicket';
import { useReactToPrint } from 'react-to-print';
import RequestDetailCmisTransferInformation from './RequestDetailCmisTransferInformation';
import ModalAssignEmployee from './Modal/ModalAssignEmployee';
import ControllerActionButton from './ControllerActionButton';
import dayjs from 'dayjs';
import ModalTransferCenter from './Modal/ModalTransferCenter';
import ModalTransferAnotherOrganizationUnit from './Modal/ModalTransferAnotherOrganizationUnit';
import ModalTransferAppCT from './Modal/ModalTransferAppCT';

type TabKey = 'pending_reception' | 'in_progress' | 'collaboration' | 'completed' | 'obstacle';

interface ticketFromDetail {
  status?: string;
  ticketId: number;
  cancelDetailModal: () => void;
  fieldTaskCaseIds?: number[];
  setInprogressTicket?: React.Dispatch<React.SetStateAction<number>>;
  fetchPartialTicketCounts?: (statuses: TabKey[]) => void;
  onActionSuccess?: (cmis?: boolean) => void;
}

const RequestDetail: React.FC<ticketFromDetail> = ({
  status = 'pending_reception',
  ticketId,
  cancelDetailModal,
  fieldTaskCaseIds,
  fetchPartialTicketCounts,
  onActionSuccess
}) => {
  // --> Print ticket
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const closeTransferModal = () => setIsOpenTransferModal(false);
  const closeObstacleModal = () => setIsOpenObstacleModal(false);
  const closeAssignModal = () => setIsAssignEmployeeModal(false);
  const closeModalCMIS = () => {
    setIsModal(false);
    cancelDetailModal();
  };
  const closeTransferCenterModal = () => setIsTransferCenterModal(false);

  // Main request detail
  const [ticketStatus, setTicketStatus] = useState(status);
  const [requestTicketId, setRequestTicketId] = useState<number>(ticketId);
  const [isHistory, setIsHistory] = useState(false);
  const { requestDetail, isLoading } = GetTicketDetail(requestTicketId);

  // Control state
  const [open, setOpen] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const [isOpenObstacleModal, setIsOpenObstacleModal] = useState(false);
  const [isOpenTransferModal, setIsOpenTransferModal] = useState(false);
  const [isAssignEmployeeModal, setIsAssignEmployeeModal] = useState(false);
  const [datePowerRestore, setDatePowerRestore] = useState<Date>(
    new Date(requestDetail?.additionalInfo?.powerRestorationAt)
  );
  const [isTransferCenterModal, setIsTransferCenterModal] = useState(false);

  const [processingContent, setProcessingContent] = useState<string>('');
  const [requestItem, setRequestItem] = useState<TicketDetail>(defaultTicketDetail);
  const [outageReasonId, setOutageReasonId] = useState<number>(requestDetail?.additionalInfo?.outageReasonId | 0);
  const [isProcessingRoomTransfer, setIsProcessingRoomTransfer] = useState(false);

  const [modalTransferOrganization, setModalTransferOrganization] = useState<boolean>(false);
  const closeModalTransferOrganization = () => {
    setModalTransferOrganization(false);
  };

  const [modalTransferAppCT, setModalTransferAppCT] = useState<boolean>(false);
  const closeModalTransferAppCT = () => {
    setModalTransferAppCT(false);
  };

  const [fieldEmployee1, setFieldEmployee1] = useState<string>();
  const [fieldEmployee2, setFieldEmployee2] = useState<string>();
  const [patchAssignCrmAppTask] = usePatchAssignCrmAppTaskMutation();
  const [turnOffTicketPriority] = usePatchTurnOffTicketPriorityMutation();
  useEffect(() => {
    setRequestItem(requestDetail);
    if (requestDetail?.isPriority == true) {
      turnOffTicketPriority(ticketId)
        .unwrap()
        .then(() => {
          window.dispatchEvent(
            new CustomEvent('ticket:read-one', {
              detail: {
                ticketId,
                status
              }
            })
          );
        });
    }
  }, [requestDetail]);

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  //Reception Pending ticket
  const [patchReception] = usePatchReceptionTicketMutation();
  const receptionTicketAction = () => {
    if (requestItem?.ticketId !== undefined) {
      Modal.confirm({
        title: 'Tiếp nhận phiếu yêu cầu',
        okText: 'Tiếp nhận',
        cancelText: 'Hủy',
        onOk() {
          patchReception(requestItem.ticketId)
            .unwrap()
            .then((res) => {
              closeModalCMIS();
              message.warning('Phiếu đang được xử lý, vui lòng chờ...', 2);
              onActionSuccess && onActionSuccess();
            });
        }
      });
    }
  };

  // --> Update OBSTACLE Ticket Action
  const [updateObstacle] = usePatchUpdateObstacleTicketMutation();
  const updateObstacleTicket = () => {
    if (!processingContent || processingContent.trim() === '') {
      message.error('Vui lòng nhập nội dung xử lý!', 3);
      return;
    }

    // Lấy phần tử đầu tiên đang active
    const activeHold = requestDetail?.ticketHoldManager?.find((x) => x?.isActive === true);
    if (!activeHold) {
      message.error('Không tìm thấy bản ghi trở ngại đang hoạt động (isActive).', 3);
      return;
    }

    const date = activeHold.estimatedEndDate ? new Date(activeHold.estimatedEndDate) : null;
    if (!date || isNaN(date.getTime())) {
      message.error('Ngày kết thúc dự kiến không hợp lệ.', 3);
      return;
    }
    const estimatedEndDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;

    const updateObstacleTicket: UpdateObstacleTicketRequest = {
      ticketId: requestDetail.ticketId,
      content: processingContent,
      estimatedEndDate,
      obstacleSourceId: activeHold.obstacleSourceId,
      ticketHoldManagerId: activeHold.ticketHoldManagerId
    };

    Modal.confirm({
      title: 'Xác nhận cập nhật trở ngại',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        updateObstacle(updateObstacleTicket)
          .unwrap()
          .then(() => {
            message.warning('Phiếu đang được xử lý, vui lòng chờ...', 2);
            onActionSuccess && onActionSuccess();
            cancelDetailModal();
          });
      }
    });
  };

  // --> Complete OBSTACLE Ticket Action
  const [isPowerRestore, setIsPowerRestore] = useState<boolean>(false);
  const [completeObstacle] = usePatchCompleteObstacleTicketMutation();
  const completeObstacleTicket = () => {
    if (!processingContent || processingContent.trim() === '') {
      message.error('Vui lòng nhập nội dung xử lý!', 3);
      return;
    }

    // Lấy phần tử đầu tiên đang active
    const activeHold = requestDetail?.ticketHoldManager?.find((x) => x?.isActive === true);
    if (!activeHold) {
      message.error('Không tìm thấy bản ghi trở ngại đang hoạt động (isActive).', 3);
      return;
    }

    const date = activeHold.estimatedEndDate ? new Date(activeHold.estimatedEndDate) : null;
    if (!date || isNaN(date.getTime())) {
      message.error('Ngày kết thúc dự kiến không hợp lệ.', 3);
      return;
    }
    const estimatedEndDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;

    const updateObstacleTicket: UpdateObstacleTicketRequest = {
      ticketId: requestDetail.ticketId,
      content: processingContent,
      estimatedEndDate,
      obstacleSourceId: activeHold.obstacleSourceId,
      ticketHoldManagerId: activeHold.ticketHoldManagerId
    };

    Modal.confirm({
      title: 'Xác nhận hoàn tất trở ngại',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        completeObstacle(updateObstacleTicket)
          .unwrap()
          .then(() => {
            message.warning('Phiếu đang được xử lý, vui lòng chờ...', 2);
            onActionSuccess && onActionSuccess();
            cancelDetailModal();
          });
      }
    });
  };

  // --> Complete COLLABORATION Ticket Action
  const [completeCollaboration] = usePatchCompleteCollaborationTicketMutation();
  const completeCollaborationTicket = () => {
    if (!processingContent || processingContent.trim() === '') {
      message.error('Vui lòng nhập nội dung xử lý!', 3);
      return;
    }

    const updateCollaborationTicket: CompleteCollaborationTicketRequest = {
      ticketId: requestDetail.ticketId,
      processingContent: processingContent
    };
    Modal.confirm({
      title: 'Xác nhận hoàn phối hợp',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        completeCollaboration(updateCollaborationTicket)
          .unwrap()
          .then(() => {
            message.warning('Phiếu đang được xử lý, vui lòng chờ...', 2);
            onActionSuccess && onActionSuccess();
            cancelDetailModal();
          });
      }
    });
  };

  // --> Complete Ticket Action
  const [completeTicket] = usePatchCompleteTicketMutation();
  const completeTicketAction = () => {
    if (requestDetail.serviceType.code === 'baoMatDien' && !isPowerRestore) {
      message.error('Vui lòng xác nhận khách hàng đã có điện lại!');
      return;
    } else if (!processingContent || processingContent.trim() === '') {
      message.error('Vui lòng nhập kết quả xử lý!');
      return;
    } else if (outageReasonId === 114) {
      message.error('Vui lòng xác định nguyên nhân mất điện trước khi hoàn tất');
      return;
    }

    const requestData: CompleteTickets = {
      ticketId,
      processingContent,
      ...(requestDetail.serviceType.code === 'baoMatDien' && {
        outageReasonId,
        powerRestorationAt: dayjs(datePowerRestore).format('YYYY-MM-DD HH:mm:ss')
      })
    };

    Modal.confirm({
      title: 'Xác nhận hoàn thành phiếu yêu cầu',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        completeTicket(requestData)
          .unwrap()
          .then((res) => {
            message.warning('Phiếu đang được xử lý, vui lòng chờ...');
            onActionSuccess && onActionSuccess();
            cancelDetailModal();
          });
      }
    });
  };

  // --> Update ticket == Inprogress ticket
  const [inprocessTicket] = usePatchInprogressTicketMutation();
  const inprocessTicketAction = async () => {
    if (!processingContent || processingContent.trim() === '') {
      message.error('Vui lòng nhập nội dung xử lý!', 3);
      return;
    }

    const fileIds = fileList.map((file) => file.response?.fileId).filter((id) => id !== undefined) as number[];

    // Create data for ticket update
    const data: InprogressTickets = {
      ticketId,
      processingContent,
      uploadFileIds: fileIds,
      ...(requestDetail.serviceType.code === 'baoMatDien' && {
        outageReasonId,
        powerRestorationAt: datePowerRestore
      }),
      isRequestMultipleTime: requestDetail?.isRequestMultipleTime,
      isNotOnTime: requestDetail?.isNotOnTime,
      isOutageEntireArea: requestDetail?.additionalInfo?.isOutageEntireArea,
      isNotRequestToSendSms: requestDetail?.additionalInfo?.isNotRequestToSendSms
    };

    Modal.confirm({
      title: 'Xác nhận cập nhật phiếu',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          await inprocessTicket(data).unwrap();

          const assignPromises = [];
          assignPromises.push(
            patchAssignCrmAppTask({
              SODIENTHOAI: fieldEmployee1 || '',
              CASE_ID_SOURCE: ticketId.toString(),
              FIELD_EMPLOYEE_POSITION: 1
            }).unwrap()
          );
          assignPromises.push(
            patchAssignCrmAppTask({
              SODIENTHOAI: fieldEmployee2 || '',
              CASE_ID_SOURCE: ticketId.toString(),
              FIELD_EMPLOYEE_POSITION: 2
            }).unwrap()
          );

          if (assignPromises.length > 0) await Promise.all(assignPromises);

          cancelDetailModal();
          setOpen(false);
          onActionSuccess && onActionSuccess();
          message.warning('Phiếu đang được xử lý, vui lòng chờ...', 2);
        } catch (error) {
          message.error('Cập nhật phiếu thất bại');
        }
      }
    });
  };

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.requestTicket} {requestDetail.ticketId}
        </Typography.Text>
      }
      className='request-form-detail-card text-center'
    >
      <div style={{ display: 'none' }}>
        <PrintComponent ref={contentRef}>
          <NormalTicket ticket={requestDetail} status={status} ticketId={ticketId} isHistory={isHistory} />
        </PrintComponent>
      </div>

      <div className='flex w-full text-left'>
        <div className='w-[250px]'>
          <RequestDetailCreateFormInformation requestItem={requestItem} />
        </div>

        {isLoading ? (
          <div className='h-[calc(95vh-8rem) flex w-[870px] items-center justify-center'>
            <Spin tip={'Đang tải'} size={'large'} />
          </div>
        ) : (
          <section className='flex flex-col'>
            <section className='h-full w-[900px] overflow-y-auto overflow-x-hidden p-6'>
              <section className='flex items-center justify-between'>
                <div className='w-4/5'>
                  <Tooltip
                    title={
                      requestItem?.serviceType && requestItem?.serviceType?.name ? requestItem?.serviceType?.name : ''
                    }
                  >
                    <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
                      {requestItem?.serviceType && requestItem?.serviceType?.name
                        ? requestItem?.serviceType?.name?.split(' ').slice(0, 10).join(' ') +
                          (requestItem?.serviceType?.name.split(' ').length > 10 ? ' ...' : '')
                        : ''}
                    </Typography.Text>
                  </Tooltip>
                </div>
                <button onClick={() => reactToPrintFn()} className='flex items-center space-x-2'>
                  <PrinterIcon />
                  <Typography.Text className='text-[16px]/[20px] text-[#1564E8]'>
                    {requestform.printTicket}
                  </Typography.Text>
                </button>
              </section>

              <section>
                <Typography.Text
                  className={`text-[14px]/[18px] font-normal italic ${
                    requestItem?.numOfRequests > 5
                      ? 'text-[#D1131D]'
                      : requestItem?.numOfRequests > 3
                        ? 'text-[#FF9500]'
                        : 'text-[#6C737E]'
                  }`}
                >
                  {requestform.customerContact} {requestItem?.numOfRequests || 0} {requestform.customerContractTime}
                </Typography.Text>
              </section>

              <section className='pb-6'>
                <RequestStatusBar status={ticketStatus} />
                {requestItem?.serviceTypeId == 1 ||
                requestItem?.serviceTypeId == 3 ||
                requestItem?.serviceTypeId == 4 ? (
                  ''
                ) : (
                  <RequestDetailCmisTransferInformation
                    ticketDetail={requestItem}
                    isHistory={isHistory}
                    onActionSuccess={() => onActionSuccess && onActionSuccess(true)}
                  />
                )}
              </section>

              <section
                className={`${
                  status === 'completed'
                    ? (requestItem?.serviceTypeId != 1 &&
                        requestItem?.serviceTypeId != 3 &&
                        requestItem?.serviceTypeId != 4) ||
                      isHistory
                      ? 'max-h-[calc(90vh-16rem)] overflow-y-auto'
                      : 'max-h-[calc(90vh-13rem)] overflow-y-auto'
                    : (requestItem?.serviceTypeId != 1 &&
                          requestItem?.serviceTypeId != 3 &&
                          requestItem?.serviceTypeId != 4) ||
                        isHistory
                      ? 'max-h-[calc(90vh-20rem)] overflow-y-auto'
                      : 'max-h-[calc(90vh-17rem)] overflow-y-auto'
                }`}
              >
                <RequestDetailMainInformation requestItem={requestItem} />
                <RequestDetailProcessing
                  //Use for customer history request
                  isHistory={isHistory}
                  requestItem={requestItem}
                  processingContent={processingContent}
                  setProcessingContent={setProcessingContent}
                  setOutageReasonId={setOutageReasonId}
                  setIsPowerRestore={setIsPowerRestore}
                  setDatePowerRestore={setDatePowerRestore}
                  fieldEmployee1={fieldEmployee1}
                  fieldEmployee2={fieldEmployee2}
                  setFieldEmployee1={setFieldEmployee1}
                  setFieldEmployee2={setFieldEmployee2}
                  fieldTaskCaseIds={fieldTaskCaseIds}
                  fileList={fileList}
                  setFileList={setFileList}
                />
              </section>
            </section>
            <ControllerActionButton
              requestItem={requestItem}
              status={ticketStatus}
              isHistory={isHistory}
              open={open}
              receptionTicketAction={receptionTicketAction}
              inprocessTicketAction={inprocessTicketAction}
              completeCollaborationTicket={completeCollaborationTicket}
              completeTicketAction={completeTicketAction}
              updateObstacleTicket={updateObstacleTicket}
              completeObstacleTicket={completeObstacleTicket}
              setIsModal={setIsModal}
              setOpen={setOpen}
              setIsOpenObstacleModal={setIsOpenObstacleModal}
              setIsOpenTransferModal={setIsOpenTransferModal}
              setIsAssignEmployeeModal={setIsAssignEmployeeModal}
              setIsProcessingRoomTransfer={setIsProcessingRoomTransfer}
              setIsTransferCenterModal={setIsTransferCenterModal}
              setModalTransferOrganization={setModalTransferOrganization}
              setModalTransferAppCT={setModalTransferAppCT}
            />
          </section>
        )}
      </div>

      {/**
       Obstacle Modal ==> socket
       Transfer Unit ==> socket
       Transfer Center ==> socket

       Transfer Cmis ==> không có socket ==>
       */}
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isOpenObstacleModal}
        onCancel={closeObstacleModal}
        footer={null}
        destroyOnClose
      >
        <ModalObstacle ticketId={ticketId} closeObstacleModal={closeObstacleModal} />
      </Modal>

      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isOpenTransferModal} // Chuyen don vi
        onCancel={closeTransferModal}
        footer={null}
        destroyOnClose
      >
        <ModalTransferUnit
          requestItem={requestItem}
          processingContent={processingContent}
          cancelDetailModal={cancelDetailModal}
          isProcessingRoomTransfer={isProcessingRoomTransfer}
        />
      </Modal>

      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isTransferCenterModal} // Chuyen trung tam
        onCancel={closeTransferCenterModal}
        footer={null}
        destroyOnClose
      >
        <ModalTransferCenter
          ticketId={ticketId}
          processingContent={processingContent}
          closeTransferCenterModal={closeTransferCenterModal}
          cancelDetailModal={cancelDetailModal}
          fetchPartialTicketCounts={fetchPartialTicketCounts}
        />
      </Modal>

      {/**  Transfer to another organization unit --> chuyen don vi xu ly phieu     **/}
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={modalTransferOrganization} // Chuyển đơn vị / phòng ban
        onCancel={closeModalTransferOrganization}
        footer={null}
        destroyOnClose
      >
        <ModalTransferAnotherOrganizationUnit
          onActionSuccess={() => onActionSuccess && onActionSuccess(true)}
          ticketId={ticketId}
        />
      </Modal>

      {/**  Transfer App CT --> Chuyển App Công trường     **/}
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[600px] rounded-xl bg-[#F5F4F6]'
        open={modalTransferAppCT} // Chuyển App công trường
        onCancel={closeModalTransferAppCT}
        footer={null}
        destroyOnClose
      >
        <ModalTransferAppCT
          ticketId={ticketId}
          cancelDetailModal={cancelDetailModal}
          onActionSuccess={() => onActionSuccess && onActionSuccess(true)}
        />
      </Modal>

      {/** Transfer CMIS Modal*/}
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isModal} // Chuyen CMIS
        onCancel={closeModalCMIS}
        footer={null}
        destroyOnClose
      >
        <ModalTransferCmis
          requestItem={requestItem}
          closeModalCMIS={closeModalCMIS}
          onActionSuccess={() => onActionSuccess && onActionSuccess(true)}
        />
      </Modal>

      {/** Assignee Modal */}
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isAssignEmployeeModal} // Giao phieu nhan vien
        onCancel={closeAssignModal}
        footer={null}
        destroyOnClose
      >
        <ModalAssignEmployee
          ticketId={ticketId}
          closeAssignModal={closeAssignModal}
          onActionSuccess={() => onActionSuccess && onActionSuccess()}
        />
      </Modal>
    </Card>
  );
};

export default RequestDetail;
